import background1 from "../images/python3procerti.jpg"; // Background images
import background2 from "../images/introtoweb.jpg";
import background3 from "../images/introtodataanalytics.png";
import background4 from "../images/csharp.jpg";
import background5 from "../images/reactjs.png";

import certificate1 from "../images/python3procerti.jpg"; // Certificate images
import certificate2 from "../images/introtoweb.jpg";
import certificate3 from "../images/introtodataanalytics.png";
import certificate4 from "../images/csharp.jpg";
import certificate5 from "../images/reactjs.png";

export const Exp = [
  {
    id: 1,
    description: "Python 3 Programming",
    bgImg: background1,  // Background image path
    certificateImg: certificate1  // Certificate image path
  },
  {
    id: 2,
    description: "Introduction To Web Development",
    bgImg: background2,
    certificateImg: certificate2,
  },
  {
    id: 3,
    description: "Introduction To Data Analytics",
    bgImg: background3,
    certificateImg: certificate3,
  },
  {
    id: 4,
    description: "Advanced CSharp Programming",
    bgImg: background4,
    certificateImg: certificate4,
  },
  {
    id: 5,
    description: "Learning ReactJS",
    bgImg: background5,
    certificateImg: certificate5,
  },
];
